export const truncateWithEllipsis = (text, length) => {
  if (typeof text !== 'string') return '';
  if (text.length <= length) return text;
  return text.slice(0, length - 3).trim() + '...';
};

export const minMaxInputNumber = (e) => {
  var n = e.target.value;
  if (n !== '') {
    n = Number(n);
  }
  if (n < 0) {
    e.target.value = 0;
  } else {
    e.target.value = n;
  }
};

export const capitalizeFirstLetter = (str) => {
  if (typeof text !== 'string') return '';
  if (!str) return;
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const hexToRgbString = (hex, fallback = '150, 193, 31') => {
  if (typeof hex !== 'string') return fallback;
  let h = hex.trim().replace(/^#/, '');
  if (h.length === 3) h = h.split('').map((c) => c + c).join('');
  if (!/^[0-9a-fA-F]{6}$/.test(h)) return fallback;
  const r = parseInt(h.slice(0, 2), 16);
  const g = parseInt(h.slice(2, 4), 16);
  const b = parseInt(h.slice(4, 6), 16);
  return `${r}, ${g}, ${b}`;
};

export const renderCurrencyLanguage = (code) => {
  if (code) {
    if (code === 'DKK') {
      return 'da';
    } else if (code === 'NOK') {
      return 'no';
    } else {
      return 'en';
    }
  } else {
    return 'en';
  }
};
